import Vue from "vue";
import VueI18n from "vue-i18n";

import { Locale } from 'vant';

import { getLanguage, setLanguage } from "@/utils/cookies";
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';


import en from "./en";
import zh from "./zh";
import kr from "./kr";
import jp from "./jp";
import tc from "./tc";



Vue.use(VueI18n);

const messages = {
  'zh': {
    ...zh,
    ...zhCN
  },
  'en': {
    ...en,
    ...enUS
  },
  'kr': {
    ...kr,
  },
  'jp': {
    ...jp,
  },
  'tc': {
    ...tc,
  },

};
export const getLocale = () => {
  const cookieLanguage = getLanguage();
  if (cookieLanguage) {
    document.documentElement.lang = cookieLanguage;
    return cookieLanguage;
  }

  const language = navigator.language.toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      document.documentElement.lang = locale;
      return locale;
    }
  }

  // Default language is english
  return "zh";
};

const CURRENT_LANG = getLocale();
console.log(CURRENT_LANG)
// first entry
Locale.use(CURRENT_LANG, messages[CURRENT_LANG])

const i18n = new VueI18n({
  locale: CURRENT_LANG,
  messages
});


export const setI18nLanguage = lang => {
  i18n.locale = lang;
  document.documentElement.lang = lang;
  setLanguage(lang);
  Locale.use(lang, messages[lang]);
  return lang;
};

export default i18n;
